export default function StatusBadge({ isActive }) {
  return (
    <span className={`badge ${isActive ? 'badge-active' : 'badge-inactive'}`}>
      {isActive ? '● ACTIVE' : '○ INACTIVE'}
    </span>
  )
}
